import type { LucideIcon } from 'lucide-react'
import {
  GitCompare,
  LayoutDashboard,
  Library,
  List,
  MessageSquare,
  Settings,
} from 'lucide-react'

export interface NavItem {
  to: string
  label: string
  shortLabel: string
  icon: LucideIcon
  testId: string
}

export const NAV_ITEMS: NavItem[] = [
  {
    to: '/dashboard',
    label: 'Dashboard',
    shortLabel: 'Home',
    icon: LayoutDashboard,
    testId: 'app-nav-dashboard',
  },
  {
    to: '/catalog',
    label: 'Catalog',
    shortLabel: 'Catalog',
    icon: Library,
    testId: 'app-nav-catalog',
  },
  {
    to: '/chat',
    label: 'Chat',
    shortLabel: 'Chat',
    icon: MessageSquare,
    testId: 'app-nav-chat',
  },
  {
    to: '/compare/batch-demo',
    label: 'Compare',
    shortLabel: 'Compare',
    icon: GitCompare,
    testId: 'app-nav-compare',
  },
  {
    to: '/sessions',
    label: 'Sessions',
    shortLabel: 'Sessions',
    icon: List,
    testId: 'app-nav-sessions',
  },
  {
    to: '/settings',
    label: 'Settings',
    shortLabel: 'Settings',
    icon: Settings,
    testId: 'app-nav-settings',
  },
]

export function isNavActive(pathname: string, to: string): boolean {
  if (to === '/dashboard') return pathname === '/dashboard' || pathname === '/'
  return pathname.startsWith(to)
}
